import { Circle, Settings } from "react-feather";

export default [
  {
    header: "Account",
  },
  {
    id: "settings",
    title: "Settings",
    icon: <Settings size={20} />,
    children: [
      {
        id: "accountSettings",
        title: "Account Settings",
        icon: <Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/pages/account-settings",
      },
      {
        id: "accountSettingsSecurity",
        title: "Security",
        icon: <Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/pages/account-settings-security",
      },
      {
        id: "accountFaq",
        title: "FAQ",
        icon: <Circle size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/pages/faq",
      },
    ],
  },
];
